import { Directive, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";
import { Subject, takeUntil } from "rxjs";

import { ClientModeService } from "~core/services/client-mode.service";

/** Renders its content (a price, or a way to reach one) unless client mode is on. */
@Directive({
	selector: '[appHidePrice]',
})
export class HidePriceDirective implements OnInit, OnDestroy {
	private directiveDestroyed$: Subject<boolean> = new Subject();

	constructor(
		private readonly templateRef: TemplateRef<unknown>,
		private readonly viewContainer: ViewContainerRef,
		private readonly clientModeService: ClientModeService
	) {}

	public ngOnInit(): void {
		this.clientModeService.active$
			.pipe(takeUntil(this.directiveDestroyed$))
			.subscribe((clientMode) => {
				this.viewContainer.clear();
				if (!clientMode) {
					this.viewContainer.createEmbeddedView(this.templateRef);
				}
			});
	}

	public ngOnDestroy(): void {
		this.directiveDestroyed$.next(true);
		this.directiveDestroyed$.complete();
	}
}
